import { Box } from "@mui/material";
import ShDateRangePicker from "../../../../../theme/ShDateRangePicker";
import { calculateWarehouseLocationsOccupancyDateTimeCategoryRelations } from "../../../reportUtils";
import { chartDateOptions } from "../../../chartFilterEnums";
import { useState } from "react";

export const WarehouseLocationOccupanceDateTimeCategory = (props) => {
    const [toFrom,setToFrom] = useState(() => {
        // If currentReport has dynamic date with from/to, use those values
        if (props.currentReport?.date?.type === chartDateOptions.DYNAMIC &&
            props.currentReport?.date?.from &&
            props.currentReport?.date?.to) {
            return {
                from: props.currentReport.date.from,
                to: props.currentReport.date.to
            };
        }
        // Otherwise calculate initial values
        return calculateWarehouseLocationsOccupancyDateTimeCategoryRelations();
    });
    return (
        <Box
            sx={{
                "@media screen and (max-width: 47.9375em)" : {
                    mx:1.5,
                    mb:1.5,
                }
            }}
        >
            <ShDateRangePicker
                startDate={toFrom.from}
                endDate={toFrom.to}
                singleSelect={true}
                explicit={true}
                select={(e) => {
                    props.setCurrentReport(prev => {
                        const startDate = new Date(e[0].formattedStartDate);

                        // Get current date in UTC (without time)
                        const nowUTC = new Date();
                        const todayUTC = new Date(Date.UTC(
                            nowUTC.getUTCFullYear(),
                            nowUTC.getUTCMonth(),
                            nowUTC.getUTCDate()
                        ));

                        // Get start date in UTC (without time)
                        const startUTC = new Date(Date.UTC(
                            startDate.getUTCFullYear(),
                            startDate.getUTCMonth(),
                            startDate.getUTCDate()
                        ));

                        // Determine if start date is today in UTC
                        const isTodayUTC = startUTC.getTime() === todayUTC.getTime();
                        setToFrom({
                            from:e[0].formattedStartDate,
                            to:e[0].formattedEndDate,
                        })

                        return {
                            ...prev,
                            date: {
                                ...(isTodayUTC
                                    ? { type: chartDateOptions.RELATIVE, frame: "1D", days: 1 }
                                    : { type: chartDateOptions.DYNAMIC, frame: "1D", from: e[0].formattedStartDate, to: e[0].formattedEndDate })
                            }
                        };
                    });
                }}
            />
        </Box>
    );
}